import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import RegistrationView from '@/views/RegistrationView.vue'
import RemindersView from '@/views/RemindersView.vue'
import ConsentView from '@/views/ConsentView.vue'
import ConfirmView from '@/views/ConfirmView.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'PAPSI Run 2025',
    },
  },
  {
    path: '/registration',
    name: 'registration',
    component: RegistrationView,
    meta: {
      title: 'Registration',
    },
  },
  {
    path: '/reminders',
    name: 'reminders',
    component: RemindersView,
    meta: {
      title: 'Reminders (Safety and Security)',
    },
  },
  {
    path: '/consent',
    name: 'consent',
    component: ConsentView,
    meta: {
      title: 'Photo and Video Consent',
    },
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: ConfirmView,
    meta: {
      title: 'Confirm Submission',
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// ✅ This only updates the document title on route change
// router.beforeEach((to, from, next) => {
//   if (to.meta && to.meta.title) {
//     document.title = to.meta.title
//   } else {
//     document.title = 'PAPSI Run' // fallback title
//   }
//   next()
// })

router.beforeEach((to, from, next) => {

  document.title = to.meta?.title || "PAPSI Run 2025";

  const protectedRoutes = ["reminders", "confirm"];
  const vuexHasForm = Boolean(store.state.form && store.state.form.length);
  const sessionHasForm = Boolean(sessionStorage.getItem("formData"));
  const hasFormData = vuexHasForm || sessionHasForm;

  if (protectedRoutes.includes(to.name) && !hasFormData) {
    console.warn("Redirecting to home — missing form data");
    return next({ name: "home" });
  }

  next();
});

export default router
